import React from 'react';
import SelectRender from './SelectRender';
import {SelectProps} from 'interfaces';

export const Select = ({...props}:SelectProps):JSX.Element=>{
	return <SelectRender {...props}/>;
};
